<template>
  <div>
    <!-- Start Page Title -->
    <div v-if="false" class="page-title-area">
      <div class="d-table">
        <div class="d-table-cell">
          <div class="container">
            <h2>Checkout</h2>
          </div>
        </div>
      </div>
    </div>
    <!-- End Page Title -->

    <!-- Start Checkout Area -->
    <section class="checkout-area ptb-80">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <div class="user-actions">
              <i data-feather="edit"></i>
              <span v-if="v2"
                >Returning customer? <a href="#">Click here to login</a></span
              >
            </div>
          </div>
        </div>

        <form>
          <div class="row">
            <OrderForm></OrderForm>
            <Orders :shopping-cart="shoppingCart" :total-amount="totalAmount" />
          </div>
        </form>
      </div>
    </section>
    <!-- End Checkout Area -->
  </div>
</template>

<script>
import OrderForm from "../common/orderForm";
import Orders from "../common/orders";
export default {
  name: "Checkout",
  components: {
    OrderForm,
    Orders
  },
  props: {
    shoppingCart: {
      type: Array,
      required: false,
      default: () => []
    },
    totalAmount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      v2: false
    };
  }
};
</script>
<style lang="scss" scoped>
@import "../../../assets/style/style.scss";
</style>
